"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInfo = function UserInfo(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$subreddit = _ref.subreddit,
      subreddit = _ref$subreddit === undefined ? "reddit.com" : _ref$subreddit,
      loginUrl = _ref.loginUrl,
      signupUrl = _ref.signupUrl,
      prefsUrl = _ref.prefsUrl,
      messagesUrl = _ref.messagesUrl,
      logoutUrl = _ref.logoutUrl,
      username = _ref.username,
      link_karma = _ref.link_karma,
      onLogout = _ref.onLogout;
  return username ? _react2.default.createElement(
    "div",
    { id: "header-bottom-right" },
    _react2.default.createElement(
      "span",
      { className: "user" },
      _react2.default.createElement(
        Link,
        { href: "/user/" + username + "/" },
        username
      ),
      " ",
      link_karma ? _react2.default.createElement(
        _react.Fragment,
        null,
        "(",
        _react2.default.createElement(
          "span",
          { className: "userkarma", title: "post karma" },
          link_karma
        ),
        ")"
      ) : null
    ),
    messagesUrl ? _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        "span",
        { className: "separator" },
        "|"
      ),
      _react2.default.createElement(
        Link,
        {
          className: "nohavemail",
          href: messagesUrl,
          id: "mail",
          title: "no new mail"
        },
        "messages"
      )
    ) : null,
    prefsUrl ? _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        "span",
        { className: "separator" },
        "|"
      ),
      _react2.default.createElement(
        "ul",
        { className: "flat-list hover" },
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            Link,
            { className: "pref-lang choice", href: prefsUrl },
            "preferences"
          )
        )
      )
    ) : null,
    onLogout || logoutUrl ? _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        "span",
        { className: "separator" },
        "|"
      ),
      _react2.default.createElement(
        "form",
        { className: "logout hover" },
        _react2.default.createElement("input", { name: "uh", type: "hidden", defaultValue: username }),
        _react2.default.createElement("input", { name: "top", type: "hidden", defaultValue: "off" }),
        _react2.default.createElement("input", { name: "dest", type: "hidden", defaultValue: "/r/{subreddit}/" }),
        _react2.default.createElement(
          "a",
          { href: logoutUrl || "", onClick: onLogout },
          "logout"
        )
      )
    ) : null
  ) : loginUrl ? _react2.default.createElement(
    "div",
    { id: "header-bottom-right" },
    "Want to join ? ",
    _react2.default.createElement(
      Link,
      { href: loginUrl, className: "login-required login-link" },
      "Log in"
    ),
    " or ",
    _react2.default.createElement(
      Link,
      { href: signupUrl || loginUrl, className: "login-required" },
      "sign up"
    ),
    " in seconds."
  ) : null;
};

exports.default = UserInfo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/UserInfo.js
// module id = 317
// module chunks = 0